module.exports = __webpack_public_path__ + "img/thumbs-down.dad2b8fe.svg";